<div class="wgu-container">
  <h2>Setup your Account</h2>

  <div class="h1">Step 5: Create a Password and Enter Your Personal Email</div>

  <p class="mb-6">
    Common and easily guessable passwords will be blocked. Examples include
    Welcome12345, password1234, and 111111111111. Please enter and confirm your
    new password.
  </p>

  <p class="mb-6">Password must meet the following strength requirements:.</p>

  <div>
    <ul>
    <li>Must contain at least 12 characters and no more than 32</li>
    <li>Must contain at least one of the following:</li>
    <li class="mx-8">An uppercase letter</li>
    <li class="mx-8">A lowercase letter</li>
    <li class="mx-8">A numerical digit</li>
    <li>Can include basic symbols</li>
    <li>Do not include your name or username</li>
    <li>Do not use a password that you use elsewhere</li>
    <li>
      Do not include personal information, such as your birthday or Social
      Security number
    </li>
  </ul>
  </div>

  <div class="col-md-4">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div>
        <em>{{ errorResponse }}</em>
      </div>

      <div class="form-group">
        <label class="wgu-outlined general">
          <input
            [ngClass]="{
              error:
                registerForm.controls.password?.invalid &&
                registerForm.controls.password?.touched,
              'error-has-value':
                registerForm.controls.password?.invalid &&
                registerForm.controls.password?.value
            }"
            formControlName="password"
            name="password"
            id="password"
            type="password"
            class="form-control"
            placeholder="   "
          />
          <span
            [ngClass]="{
              error:
                registerForm.controls.password?.invalid &&
                registerForm.controls.password?.touched
            }"
            >Password</span
          >
          <p
            *ngIf="
              f.password?.errors?.required &&
              registerForm.controls.password?.touched
            "
            class="error-label"
          >
            Password is required
          </p>
          <p
            *ngIf="
              f.password?.errors?.minlength &&
              registerForm.controls.password?.touched
            "
            class="error-label"
          >
            Password must be at least 12 characters
          </p>
          <p
            *ngIf="
              f.password?.errors?.general &&
              registerForm.controls.password?.touched
            "
            class="error-label"
          >
            Password is missing a Capital/Lower letter or a digit
          </p>
          <button
            [ngClass]="{
              imgoffadj:
                registerForm.controls.password?.invalid &&
                registerForm.controls.password?.touched
            }"
            (click)="toggle('passwordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password"
              id="psweyeon"
              [src]="passwordShow ? '/assets/icons/eye-on.svg' : '/assets/icons/eye-off.svg'"
              width="25"
            />
          </button>
         
        </label>
      </div>

      <div class=""></div>

      <div class="form-group mb-12">
        <label class="wgu-outlined general">
          <input
            [ngClass]="{
              error:
                registerForm.controls.new_password?.invalid &&
                registerForm.controls.new_password?.touched,
              'error-has-value':
                registerForm.controls.new_password?.invalid &&
                registerForm.controls.new_password?.value
            }"
            formControlName="new_password"
            name="new_password"
            id="new_password"
            type="password"
            class="form-control"
            placeholder="   "
          />
          <span
            [ngClass]="{
              error:
                registerForm.controls.new_password?.invalid &&
                registerForm.controls.new_password?.touched,
              'error-has-value':
                registerForm.controls.password?.invalid &&
                registerForm.controls.password?.value
            }"
            >Confirm Password</span
          >

          <p
            *ngIf="
              f.new_password?.errors?.mustMatch &&
              registerForm.controls.new_password?.touched
            "
            class="error-label"
          >
            Passwords must match
          </p>
          <button
            [ngClass]="{
              imgoffadj:
                registerForm.controls.new_password?.invalid &&
                registerForm.controls.new_password?.touched
            }"
            (click)="toggle('new_passwordShow')"
            type="button"
          >
            <img
              alt="Show/Hide Password"
              id="newpsweyeon"
              [src]="new_passwordShow ? '/assets/icons/eye-on.svg' : '/assets/icons/eye-off.svg'"
              width="25"
            />
          </button>
        </label>
      </div>

      <p class="mb-6">
        Please enter in a personal email that you would like to link to your WGU
        account. This email will be used in case you forget your WGU username.
      </p>

      <p class="mb-6">
        Your WGU Username is <strong>{{ claim?.user_name }}</strong
        >.
      </p>

      <div class="form-group">
        <label class="wgu-outlined general">
          <!--  *ngIf="errorResponse"    <em *ngIf="loginForm.controls.first_name?.invalid && (loginForm.controls.first_name?.touched || mouseoverLogin)">Required</em>-->
          <input
            [ngClass]="{
              error:
                registerForm.controls.email?.invalid &&
                registerForm.controls.email?.touched,
              'error-has-value':
                registerForm.controls.email?.invalid &&
                registerForm.controls.email?.value
            }"
            formControlName="email"
            name="email"
            id="email"
            type="text"
            class="form-control"
            placeholder="   "
          />
          <span
            [ngClass]="{
              error:
                registerForm.controls.email?.invalid &&
                registerForm.controls.email?.touched
            }"
            >Personal Email</span
          >

          <p
            *ngIf="
              f.email?.errors?.required && registerForm.controls.email?.touched
            "
            class="error-label"
          >
            Email is required
          </p>
          <p
            *ngIf="
              f.email?.errors?.email && registerForm.controls.email?.touched
            "
            class="error-label"
          >
            Email must be a valid email address
          </p>
        </label>
      </div>

      <div class="form-actions">
        <button class="wgu-btn" type="submit">{{ submitted == true ? 'Submitting...' : 'Next' }}</button>
        <a href="identityiq/external/cancelPage" class="wgu-btn-text">Cancel</a>
      </div>
    </form>
  </div>
</div>
